import * as api from 'app/api';
import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { pender } from 'redux-pender';

const GET_DUPLICATE_JOIN_DATA = 'join.sns/GET_DUPLICATE_JOIN_DATA';
export const getDuplicateJoinData = createAction(GET_DUPLICATE_JOIN_DATA, api.checkDuplicateSns);

const initialState = {
	isInit: false,
	hasBeforeSocialAgreement: false,
	duplicateList: [],
};

export default handleActions(
	{
		...pender({
			type: GET_DUPLICATE_JOIN_DATA,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.isInit = true;
					draft.hasBeforeSocialAgreement = data.hasBeforeSocialAgreement;
					draft.duplicateList = data.signedSites;
				}),
			onFailure: (state) =>
				produce(state, (draft) => {
					draft.isInit = true;
					draft.duplicateList = [];
				}),
		}),
	},
	initialState,
);
